// File: BusinessLoungeAboutSection.jsx
// Pure CSS Luxe Business Lounge Style

import { Lightbulb, MapPinHouse, Star } from 'lucide-react';
import React from 'react';
export default function AboutUsCard10() {
  return (<>
    <section className="bl-sec-ac-10">
      <div className="bl-left-ac-10">
        <div className="feature-ac-10s">
         <div className="cp-years">
          <div className="big-ac-10">25</div>
          <div className="label-ac-10-two">Years Experience</div>
        </div>
            <div className="feature-ac-10">
              <div className="ficon-ac-10"><Lightbulb size={20} color={`#fff`} /></div>
              <div>
                <strong>Professional Service</strong>
                <p className="small-ac-10">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>

            <div className="feature-ac-10">
              <div className="ficon-ac-10"><MapPinHouse size={20} color={`#fff`} /></div>
              <div>
                <strong>100% Service Guarantee</strong>
                <p className="small-ac-10">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div>
      </div>

      <div className="bl-right-ac-10">
        <div className="ratings-ac-10">
          <img
            src="https://i.pravatar.cc/50?img=1"
            className="avatar-ac-10"
            alt=""
          />
          <img
            src="https://i.pravatar.cc/50?img=3"
            className="avatar-ac-10"
            alt=""
          />
          <img
            src="https://i.pravatar.cc/50?img=4"
            className="avatar-ac-10"
            alt=""
          />
          <span className="rate-text-ac-10-ac-10">5 <Star size={16} color={`#222222`}/> Ratings</span>
        </div>

        <h5 className="sup-ac-10">About Us</h5>
        <h2 className="title-ac-10">Executive Oasis</h2>

        <p className="text-ac-10">
          Welcome to Executive Oasis, your premier destination for sophisticated business accommodations
          and modern amenities. We curate a haven where business excellence meets unparalleled comfort.
        </p>

        <div className="stat-ac-10s-box-ac-10">
          <div className="stat-ac-10">
            <span className="num-ac-10">50K+</span>
            <p>Global Happy Clients</p>
          </div>
          <div className="stat-ac-10">
            <span className="num-ac-10">16+</span>
            <p>Services</p>
          </div>
          <div className="stat-ac-10">
            <span className="num-ac-10">12+</span>
            <p>Years Experience</p>
          </div>
          <div className="stat-ac-10">
            <span className="num-ac-10">4.5+</span>
            <p>Rating</p>
          </div>
        </div>
      </div>
    </section>
    <style>{`
/* File: BusinessLoungeAboutSection.css */


.big-ac-10 {
  font-size: 70px;
  font-weight: 800;
}


.label-ac-10-two {
  font-size: 22px;
  margin-top: 6px;
  letter-spacing: 0.5px;
  color: rgba(144, 202, 249,1);
}
.feature-ac-10s{ margin-top:18px}
.feature-ac-10{display:flex; gap:12px; align-items:flex-start; flex:1; margin-top:18px;
  background: rgba(0,0,0,0.35);padding:18px 25px;border-radius:10px;}
.ficon-ac-10{display:flex; align-items:center; justify-content:center; border-radius:10px; background:rgba(144, 202, 249,1);padding:8px 12px; }
.feature-ac-10 .small-ac-10{font-size:13px; margin:6px 0 0; opacity:0.9}

.bl-sec-ac-10 {
  display: flex;
  align-items: center;
  gap: 50px;
  padding: 60px 50px;
  background:#111418;
  color: #fff;
  font-family: Inter, sans-serif;
}

/* LEFT */
.bl-left-ac-10 { flex: 1; position: relative;padding: 40px 60px; }
.bl-img-ac-10 {
  width: 100%;
  border-radius: 30px;
  border: 2px dashed rgba(144, 202, 249,0.31);
  object-fit: cover;
}

/* RIGHT */
.bl-right-ac-10 { flex: 1; max-width: 540px; }
.ratings-ac-10 {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(144, 202, 249,1);
  padding: 6px 18px;
  border-radius: 12px;
  margin-bottom: 18px;
  width: fit-content;
}
.avatar-ac-10 {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid #fff;
}
.rate-text-ac-10-ac-10 {
  font-size: 14px;display:flex;justify-content:left;gap:2px;
  font-weight: 700;
  color: #000;padding:5px 15px;
}

.sup-ac-10 {
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 700;padding:5px 15px;
  color: rgba(144, 202, 249,1);
  text-ac-10-transform: uppercase;
}
.title-ac-10 {
  font-size: 34px;
  font-weight: 800;padding:5px 15px;
  margin: 10px 0 18px;
}
.text-ac-10 {
  line-height: 1.7;
  font-size: 15px;padding:5px 15px;
  color: #ddd;
  margin-bottom: 30px;
}

/* STATS CARD */
.stat-ac-10s-box-ac-10 {
  display: flex;
  gap: 20px;
  background: rgba(0,0,0,0.35);
  padding: 22px;
  border-radius: 18px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.stat-ac-10 { text-align: center; flex: 1; }
.num-ac-10 {
  font-size: 26px;
  font-weight: 800;
  color: rgba(144, 202, 249,1);
}
.stat-ac-10 p {
  color: #ddd;
  font-size: 13px;
  margin-top: 6px;
}

/* Responsive */
@media(max-width:960px){
  .bl-sec-ac-10 { flex-direction: column; padding: 60px 10px; }
  .bl-right-ac-10 { max-width: 100%; }
  .bl-left-ac-10 { padding: 40px 10px; }
  .feature-ac-10{padding:10px 15px;}
  .stat-ac-10s-box-ac-10 { flex-wrap: wrap; }
}`}</style>
    </>
  );
}
